import React from "react"
import styled from 'styled-components'

const Goals = () => {
  return (
    <StyledWrapper>
      <H2>My current goals &#128221;</H2>
      <Paragraph>&#128640; Develop research projects</Paragraph>
      <Paragraph>&#127891; Obtaining Bachelor's Degree</Paragraph>
      <Paragraph>&#128519; Personal development</Paragraph>
    </StyledWrapper>
  )
}

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  max-width: 520px;
`

const H2 = styled.h2`
  font-weight: ${({theme}) => theme.font.semiBold};
  font-size: 30px;
  color: ${({theme}) => theme.color.black};
  position: relative;
  margin-bottom: 4px;
  
  ${({theme}) => theme.media.phone} {
    font-size: 28px;
  }
`

const Paragraph = styled.p`
  font-weight: ${({theme}) => theme.font.regular};
  font-size: 18px;
  color: ${({theme}) => theme.color.black};
  margin: 0 0 10px 0;
  
  span {
    font-weight: ${({theme}) => theme.font.semiBold};
  }
`

export default Goals
